import { I18n } from "i18n-js";
import en_base from "i18n-js/json/en.json";
import en from "./en";
import sv_base from "i18n-js/json/sv.json";
import sv from "./sv";
import storage from "../storage";

const i18n = new I18n({
    en: {
        ...en,
        ...en_base,
    },
    sv: {
        ...sv,
        ...sv_base,
    },
});

i18n.locale = storage.getItem("locale") ?? "sv";
i18n.defaultLocale = "sv";

export { i18n };
